/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, Suspense } from "react";
import { useStoreFly } from "../store";
import { useNavigate } from "react-router-dom";
import { IsMobileOrBrowser } from "../hooks/isBrowserOrMobile";
import { DEFAULT_CITY } from "../utils/locationData";

// Lazy load the complex component to reduce initial bundle size and render delay
const DeferredPopularContent = React.lazy(() => 
  import('./DeferredPopularContent').then(module => ({ 
    default: module.DeferredPopularContent 
  }))
);

const Popular = ({ translation }) => {
  const isNotMobile = window.innerWidth > 768;
  const isMobileDevice = IsMobileOrBrowser();
  
  // Critical state only - defer the rest
  const [userCity, setUserCity] = useState(DEFAULT_CITY);

  // Store references - simplified
  const setTopFlightsHome = useStoreFly((state) => state.setTopFlightsHome);
  const topFlightsHome = useStoreFly((state) => state.topFlightsHome);
  const setReturnOrOneWayTopLocations = useStoreFly((state) => state.setReturnOrOneWayTopLocations);
  const returnOrOneWayTopLocations = useStoreFly((state) => state.returnOrOneWayTopLocations);
  const setTopLocationsPassengers = useStoreFly((state) => state.setTopLocationsPassengers);
  const topLocationsPassengers = useStoreFly((state) => state.topLocationsPassengers);
  
  // Move navigate hook before other logic
  const navigate = useNavigate();

  // Simple loading fallback for the deferred content
  const LoadingFallback = () => (
    <div className="row package-space">
      <div className="col-12 text-center">
        <div style={{ 
          padding: '40px 20px',
          color: '#666',
          fontSize: '16px'
        }}>
          Loading destinations...
        </div>
      </div>
    </div>
  );

  return (
    <section className="popular" style={isMobileDevice ? { padding: "none" } : {}}>
      <div className="container" style={{ marginTop: isNotMobile ? '50px' : '0px' }}>
        <div className="row mt-2">
          <div className="col-lg-12 section-title mb-5 text-center col-md-12 col-12" style={{ marginTop: isNotMobile ? '60px' : '20px' }}>
            <h2>
              <strong>{translation("popular")} </strong>
              <span>{translation("from")} </span>
              <span>{userCity}</span>
            </h2>
          </div>
        </div>
        
        {/* Use Suspense with lazy loading to defer complex component */}
        <Suspense fallback={<LoadingFallback />}>
          <DeferredPopularContent 
            isNotMobile={isNotMobile}
            isMobileDevice={isMobileDevice}
            translation={translation}
            navigate={navigate}
            topFlightsHome={topFlightsHome}
            setTopFlightsHome={setTopFlightsHome}
            returnOrOneWayTopLocations={returnOrOneWayTopLocations}
            setReturnOrOneWayTopLocations={setReturnOrOneWayTopLocations}
            topLocationsPassengers={topLocationsPassengers}
            setTopLocationsPassengers={setTopLocationsPassengers}
            userCity={userCity}
            setUserCity={setUserCity}
          />
        </Suspense>
      </div>
    </section>
  );
};

export default Popular;
